import { connect } from 'react-redux';
import ProgressPage from './ProgressPage';
import { Dispatch } from 'redux';
import { AppState } from '../../redux';
import { fetchCurrentUserDetails } from '../../actions/basicAction';
export const mapStateToProps = (state: AppState) => {
    return {
        loadingText: 'Processing . . .'
    };
};

export const mapDispatchToProps = (dispatch: Dispatch<AppState>) => {
    return {        
        onComponentDidMount:  (url: string) => {
            const paramsString = url.split('#' )[1];
            const params = new URLSearchParams( paramsString );
            const accessToken = params.get('access_token') || '';
            const tokenType = params.get('token_type') || '';
            const expiresIn = params.get('expires_in') || '';
            dispatch(fetchCurrentUserDetails(accessToken, tokenType, expiresIn));
        }
    };
};

const ProgressPageContainer = connect(
    mapStateToProps,
    mapDispatchToProps,
)(ProgressPage);

export default ProgressPageContainer;



// WEBPACK FOOTER //
// ./src/components/callback/ProgressPageContainer.tsx